import { render, staticRenderFns } from "./ReelControlSidebar.vue?vue&type=template&id=03b95230&scoped=true"
import script from "./ReelControlSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelControlSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelControlSidebar.vue?vue&type=style&index=0&id=03b95230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b95230",
  null
  
)

export default component.exports